export enum RelationTypeEnum {
  Official = 'CHECKIN_OFFICIAL',
  Witness = 'CHECKIN_WITNESS',
  Inspector = 'CHECKIN_INSPECTOR',
  Archive = 'CHECKIN_ARCHIVE',
  Buyer = 'CHECKIN_BUYER',
  Seller = 'CHECKIN_SELLER',
  ChildVdt = 'CHILD_VDT',
  ParentVdt = 'PARENT_VDT',
}
